import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import {
  DRIVER_MANAGEMENT,
  PLAN_MANAGEMENT,
  ROUTE_MANAGEMENT,
  SECTION_MANAGEMENT,
  SHIFT_MANAGER_MANAGEMENT,
  VOLUME_OVERLAY_TABLE,
} from "../consts/routes";

let lastQueryParams = null;
let params = {};

const getParamsFromQueryString = (queryParams) =>
  (queryParams || "")
    .replace("?", "")
    .split("&")
    .reduce((acc, keyValueString) => {
      if (!keyValueString) return acc;
      const [key, value] = keyValueString.split("=");
      acc[key] = value;
      return acc;
    }, {});

export const useLocationDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { pathname, search: queryParams } = location;

  if (queryParams !== lastQueryParams) {
    lastQueryParams = queryParams;
    params = getParamsFromQueryString(queryParams);
  }

  const isPlanManagement =
    pathname === PLAN_MANAGEMENT || pathname.startsWith(PLAN_MANAGEMENT + "/");
  const isDriverManagement =
    pathname === DRIVER_MANAGEMENT ||
    pathname.startsWith(DRIVER_MANAGEMENT + "/");
  const isSectionManagement =
    pathname === SECTION_MANAGEMENT ||
    pathname.startsWith(SECTION_MANAGEMENT + "/");
  const isRouteManagement =
    pathname === ROUTE_MANAGEMENT ||
    pathname.startsWith(ROUTE_MANAGEMENT + "/");
  const isShiftManagerManagement =
    pathname === SHIFT_MANAGER_MANAGEMENT ||
    pathname.startsWith(SHIFT_MANAGER_MANAGEMENT + "/");
  const isVolumeOverlayTable =
    pathname === VOLUME_OVERLAY_TABLE ||
    pathname.startsWith(VOLUME_OVERLAY_TABLE + "/");

  const removeParam = useCallback(
    (key) => {
      const newParams = { ...params };
      delete newParams[key];
      const newQueryParams = new URLSearchParams(newParams).toString();
      let navigateTo = pathname;
      if (newQueryParams)
        navigateTo = `${navigateTo.replace(/\/?$/, "/")}?${newQueryParams}`;

      console.log(navigateTo);
      navigate(navigateTo, {
        replace: true,
      });
    },
    [pathname, navigate]
  );

  let application = null;
  if (isDriverManagement) application = DRIVER_MANAGEMENT;
  else if (isPlanManagement) application = PLAN_MANAGEMENT;
  else if (isSectionManagement) application = SECTION_MANAGEMENT;
  else if (isRouteManagement) application = ROUTE_MANAGEMENT;
  else if (isShiftManagerManagement) application = SHIFT_MANAGER_MANAGEMENT;

  return {
    application,
    isPlanManagement,
    isDriverManagement,
    isSectionManagement,
    isRouteManagement,
    isShiftManagerManagement,
    isVolumeOverlayTable,
    params,
    removeParam,
  };
};
